const rankingItems = [
  { rank: 1, title: '斗破苍穹', heat: '9.8', change: 'up', genre: '热血玄幻', update: '周更', desc: '萧炎踏上强者之路，最新篇章燃爆全场' },
  { rank: 2, title: '海贼王', heat: '9.7', change: 'same', genre: '冒险热血', update: '周更', desc: '最终章进行中，路飞与伙伴们的终极冒险' },
  { rank: 3, title: '间谍过家家', heat: '9.5', change: 'up', genre: '家庭喜剧', update: '双周更', desc: '黄昏一家的温馨日常，阿尼亚太可爱了' },
  { rank: 4, title: '一人之下', heat: '9.4', change: 'up', genre: '都市玄幻', update: '周更', desc: '国漫天花板，异人世界的精彩纷争' },
  { rank: 5, title: '咒术回战', heat: '9.2', change: 'down', genre: '热血战斗', update: '不定期', desc: '涉谷事变后新篇章，宿傩与五条的宿命对决' },
  { rank: 6, title: '葬送的芙莉莲', heat: '9.0', change: 'up', genre: '奇幻冒险', update: '月更', desc: '时间与记忆的温柔诗篇，治愈系巅峰之作' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            人气热榜
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            全网漫画追更热度实时排行，看看本周哪些连载漫画最受漫友追捧
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href="#ranking"
                className={`flex items-center gap-4 md:gap-6 p-4 md:p-5 hover:bg-primary-50/50 transition-colors duration-200 cursor-pointer ${i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''}`}
              >
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-bold text-lg ${
                  item.rank === 1 ? 'bg-accent-500 text-white' :
                  item.rank === 2 ? 'bg-primary-500 text-white' :
                  item.rank === 3 ? 'bg-secondary-500 text-white' :
                  'bg-background-100 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                    <span className="text-xs text-foreground-400">{item.genre}</span>
                    <span className="text-xs text-foreground-400">· {item.update}</span>
                  </div>
                  <p className="text-sm text-foreground-600 truncate">{item.desc}</p>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="text-right">
                    <div className="text-lg font-bold text-primary-500">{item.heat}</div>
                    <div className="text-xs text-foreground-400">热度分</div>
                  </div>
                  <div className={`w-10 h-10 flex items-center justify-center rounded-full ${
                    item.change === 'up' ? 'text-primary-500' :
                    item.change === 'down' ? 'text-foreground-400' :
                    'text-foreground-400'
                  }`}>
                    <i className={`text-lg ${item.change === 'up' ? 'ri-arrow-up-line' : item.change === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'}`}></i>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}